import * as a from '../services/auth';
import { ActionTypes } from '../types/action-types';

export const updateKey = (accessToken: string, tenantId: string, key: string) => async dispatch => {
    const auth = await a.updateKey(accessToken, tenantId, key)
    dispatch({
        type: ActionTypes.HB_KEY_UPDATED,
        apikey: auth.key
    })
};

export const getKey = (accessToken: string, tenantId: string) => async dispatch => {
    const auth = await a.getKey(accessToken, tenantId)
    dispatch({
        type: ActionTypes.HB_KEY_UPDATED,
        apikey: auth.key
    })
};




// WEBPACK FOOTER //
// ./src/sub-projects/hubspot/actions/auth.ts